import { findProjectPhoto } from '@/data/projectPhotos';
import { PROJECT_STORIES } from '@/data/projectStories';
import imageSizes from '@/data/imageSizes.json';

const SIZES = imageSizes as unknown as Record<string, [number, number]>;

/**
 * A real photo from one of our finished projects, with its true size (for SitePhoto) and the
 * project's name and page — so placeholder slots are filled with real work, credited and linked.
 */
export function projectPhoto(projectSlug: string, file: string) {
  const p = findProjectPhoto(projectSlug, file);
  const size = p && SIZES[p.src];
  if (!p || !size) throw new Error(`Project photo not found: ${projectSlug}/${file}`);
  return {
    src: p.src,
    alt: p.alt,
    width: size[0],
    height: size[1],
    projectName: PROJECT_STORIES[projectSlug]?.name ?? '',
    projectHref: `/projects/${projectSlug}`,
  };
}
